import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";

const Categories = ({ classes, page }) => {
  SwiperCore.use([Autoplay]);
  const [categoryId, setCategoryId] = useState(-1);
  const currentLocation = useLocation();

  useEffect(() => {
    if (currentLocation.pathname === "/listings") {
      setCategoryId(-1);
    }
  }, [currentLocation]);

  const getLinkPath = (cat) => {
    if (page === "Listing") return `/listings/classes/${cat.id}`;
    if (page === "Services") return `/services/listings/classes/${cat.id}`;
    if (page === "Home") return `/classes/${cat.id}/breeds`;
    return "*";
  };

  const activeCategories = classes?.filter((cat) => cat.active) || [];

  return (
    <Box
      sx={{
        backgroundColor: "#0d0d0d",
        borderBottom: "1px solid #1e1e1e",
        py: 1.5,
        px: { xs: 1, md: 2 },
      }}
    >
      <Swiper
        style={{ "--swiper-navigation-color": "#FFC001" }}
        navigation={true}
        modules={[Navigation]}
        grabCursor={true}
        spaceBetween={8}
        breakpoints={{
          320: { slidesPerView: 3.2 },
          480: { slidesPerView: 4.5 },
          600: { slidesPerView: 5.5 },
          900: { slidesPerView: 7.5 },
          1200: { slidesPerView: 10 },
          1500: { slidesPerView: 12 },
        }}
      >
        {activeCategories.map((cat) => {
          const isSelected = categoryId === cat.id;
          return (
            <SwiperSlide key={cat.id}>
              <Box
                component={Link}
                to={getLinkPath(cat)}
                onClick={() => setCategoryId(cat.id)}
                sx={{
                  display: "block",
                  textDecoration: "none",
                  borderRadius: "10px",
                  overflow: "hidden",
                  position: "relative",
                  height: { xs: "64px", md: "72px" },
                  border: isSelected ? "2px solid #FFC001" : "1px solid #2a2a2a",
                  boxShadow: isSelected ? "0 0 14px rgba(255,192,1,0.3)" : "none",
                  transition: "all 0.25s ease",
                  "&:hover": {
                    borderColor: "#FFC001",
                    "& .cat-slide-bg": { filter: "blur(3px) brightness(0.35)", transform: "scale(1.08)" },
                  },
                }}
              >
                {/* Background image */}
                <Box
                  className="cat-slide-bg"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: cat.image ? `url(${cat.image})` : "none",
                    backgroundColor: cat.image ? "transparent" : "#1a1a1a",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: isSelected
                      ? "blur(3px) brightness(0.3)"
                      : "blur(0px) brightness(0.5)",
                    transform: "scale(1.0)",
                    transition: "all 0.35s ease",
                  }}
                />

                {/* Gradient overlay */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.15) 100%)",
                  }}
                />

                {/* Gold top accent line */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 0, left: 0, right: 0,
                    height: "2px",
                    backgroundColor: "#FFC001",
                    opacity: isSelected ? 1 : 0.5,
                    transition: "opacity 0.25s ease",
                  }}
                />

                {/* Name */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0, left: 0, right: 0,
                    px: 0.8,
                    pb: 0.6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      color: isSelected ? "#FFC001" : "#ddd",
                      fontWeight: isSelected ? 700 : 600,
                      fontSize: { xs: "10px", md: "11px" },
                      textAlign: "center",
                      textShadow: "0 1px 4px rgba(0,0,0,0.9)",
                      transition: "color 0.25s ease",
                    }}
                  >
                    {cat.name}
                  </Typography>
                </Box>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Box>
  );
};

export default Categories;
